import './style';

import { Component } from 'preact';
import createHistory from 'history/createBrowserHistory';
import { Container, Row, Col } from 'reactstrap';

import ploneApi from "api/PloneApi";

import { LinkHandlerContext } from 'components/Contexts';
import Navigation from 'components/Navigations';
import ContentTypeSwitch from 'components/ContentTypeSwitch';
import Panorama from 'components/Panorama';
import Spinner from 'components/Spinner';
import PloneLink from "./components/PloneLink";

export default class App extends Component {
    constructor(props) {
        super(props);

        this.history = createHistory();
        this.historyListen();



        this.state = {
            location: location.pathname + location.search + location.hash,
            fetching: false,
            content: {},
            contentState: 3, // 0: hidden, 1: teaser-mode, 2: full (panorama still visible), 3: full (with all space)
            buttonVisible: false,
            panorama: false,
            breadcrumbs: null
        };

        this.openLink = this.openLink.bind(this);
        this.panoramaSlideIn = this.panoramaSlideIn.bind(this);
        this.panoramaSlideOut = this.panoramaSlideOut.bind(this);
        this.contentButtonClickHandler = this.contentButtonClickHandler.bind(this);
        this.contentScroll = this.contentScroll.bind(this);
    }

    historyListen() {
        this.historyUnlisten = this.history.listen((location, action) => {
            //console.log(action, location.pathname, location.state)
            this.fetchData(location.pathname, false);
        });
    }

    historyPush(path) {
        this.historyUnlisten();
        this.history.push(ploneApi.publicPath + path);
        this.historyListen();
    }

    fetchData(path, historyPush = true, panoramaPointsSmall = false) {
        this.setState({
            fetching: true
        });

        ploneApi.fetch(path, true)
            .then(data => {
                if(data["@type"] === "panorama") {
                    this.setState({
                        fetching: false,
                        panorama: data,
                        contentState: 0
                    });
                } else {
                    let newContentState, newButtonVisibleState;
                    if (data["@type"] === "panorama-point" && panoramaPointsSmall) {
                        newContentState = 1;
                        newButtonVisibleState = true;
                    } else {
                        newContentState = 3;
                        newButtonVisibleState = false;
                    }

                    let breadcrumbs = null;
                    if (data["@type"] !== "panorama-point") {
                        breadcrumbs = data["@components"].breadcrumbs.items;
                        breadcrumbs.pop();
                    }

                    this.setState({
                        fetching: false,
                        content: data,
                        contentState: newContentState,
                        buttonVisible: newButtonVisibleState,
                        breadcrumbs: breadcrumbs
                    });
                }

                if(historyPush) {
                    this.historyPush(path);
                }
            })
    }

    openLink(path) {
        this.fetchData(path);
    }

    panoramaSlideIn(ploneObject) {
        if(this.state.content["@id"] === ploneObject["@id"] && this.state.contentState > 0) {
            return;
        }

        const timeOut = (this.state.contentState === 0) ? 0 : 500;
        this.setState({
            contentState: 0
        });
        window.setTimeout(() => {
            this.fetchData(ploneObject["@id"], false, true);
        }, timeOut);
    }

    panoramaSlideOut() {
        if(this.state.contentState === 0) {
            return;
        }
        this.setState({
            contentState: 0
        });
        this.historyPush(this.state.panorama["@id"]);
    }

    nextContentState() {
        let newContentState;

        switch(this.state.contentState) {
            case 1:
                const c = this.state.content;
                if(c["@type"] === "panorama-point" && c["external-url"] && c["external-url"].trim() !== "") {
                    newContentState = 3;
                } else {
                    newContentState = 2;
                }

                this.historyPush(c["@id"]);
                break;
            case 2:
                this.panoramaSlideOut();
                return;
                break;
            case 3:
                this.panoramaSlideOut();
                return;
                break;
        }
        this.setState({
            contentState: newContentState
        })
    }

    contentButtonClickHandler(e) {
        e.preventDefault();
        this.nextContentState();
    }

    contentScroll(e) {
        if(this.state.contentState === 1) {
            e.preventDefault();
            this.nextContentState();
        }
    }

    componentDidMount() {
        const initialPath = this.state.location.slice(ploneApi.publicPath.length);
        this.fetchData(initialPath, false);
    }

    componentDidUpdate(prevProps, prevState) {
        // // Typical usage (don't forget to compare props):
        if (prevState.content !== this.state.content
            || prevState.contentState === 0 && this.state.contentState === 1) {
            this.contentWrapper.scrollTop = 0;
        }
    }

	render() {
	    const context = {
	        openLink: this.openLink
        };

	    const iFrame = (this.state.content["@type"] === "panorama-point" && this.state.content["external-url"]);

	    const panoramaElem = !this.state.panorama ? null : (
	        <Panorama item={ this.state.panorama } runRenderer={ (this.state.contentState < 3) } panoramaFunctions={{ panoramaSlideIn: this.panoramaSlideIn, panoramaSlideOut: this.panoramaSlideOut }} />
        );

	    let breadcrumbsElem;
	    if(this.state.breadcrumbs && this.state.breadcrumbs.length) {
            let breadcrumbsElems = this.state.breadcrumbs && this.state.breadcrumbs.map(breadcrumb => {
                return <li><PloneLink item={ breadcrumb }>{ breadcrumb.title }</PloneLink></li>;
            });
            breadcrumbsElems.push(<li>{ this.state.content.title }</li>);
            breadcrumbsElem = <nav className="breadcrumbs small">Sie befinden sich hier: <ul>{ breadcrumbsElems }</ul></nav>;
        } else {
            breadcrumbsElem = {};
        }


	    return (
			<LinkHandlerContext.Provider value={ context }>
                { panoramaElem }
                <Navigation/>
                <div className={ "main-content main-content-" + this.state.contentState }>
                    <div className={ "content-wrapper " + (iFrame ? "iframe" : "") } ref={ ref => { this.contentWrapper = ref; } } onScroll={ this.contentScroll } onTouchStart={ this.contentScroll }>

                        {
                            iFrame ?
                                <iframe src={ this.state.content["external-url"] }  onScroll={ this.contentScroll } onTouchStart={ this.contentScroll } />
                            :
                                (
                                    <Container>
                                        <Row>
                                            <Col>
                                                { breadcrumbsElem }
                                                <ContentTypeSwitch item={ this.state.content } />
                                            </Col>
                                        </Row>
                                    </Container>
                                  )
                        }

                    </div>
                    <a id="button" href="#"
                       className={ this.state.contentState >= 2 ? "rotated" : null }
                       onClick={ this.contentButtonClickHandler }
                       style={ (!this.state.buttonVisible || this.state.contentState === 0) ? { display: "none" } : null } />
                </div>
                { this.state.fetching && <Spinner /> }
            </LinkHandlerContext.Provider>
		);
	}
}



// WEBPACK FOOTER //
// ./index.js